import {IGameFilterDefinition} from '../interfaces/game-filter-definition.interface';
import {GameInfo} from '../../games/game-info';
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class CustomFilter implements IGameFilterDefinition {
  constructor(public readonly id: string,
              private readonly _evaluate: (gameInfo: GameInfo) => boolean) {
  }

  applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
    if(this._evaluate(gameInfo)) {
      return ApplyGameFilterResult.IncludeGame;
    }
    return ApplyGameFilterResult.ExcludeGame;
  }
}
